import { render, staticRenderFns } from "./variants.vue?vue&type=template&id=a098d1a2&"
import script from "./variants.vue?vue&type=script&lang=js&"
export * from "./variants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports